module.exports = __webpack_public_path__ + "img/blue-letter-icon.acfd8864.svg";